import React from "react";
import clsx from "clsx";
import useClasses from "../useClasses";

export default function CustomContent({ open, content, marginLeft }) {
  const styles = (theme) => ({
    content: {
      flexGrow: 1,
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    contentShift: {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      [theme.breakpoints.up("md")]: {
        marginLeft: marginLeft,
      },
    },
  });
  const classes = useClasses(styles);
  return (
    <div
      className={clsx(classes.content, {
        [classes.contentShift]: open,
      })}
    >
      {content}
    </div>
  );
}
